import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { TableSharedCssClassName } from '@atlaskit/editor-common/styles';
export var TableStickyScrollbar = /*#__PURE__*/function () {
  function TableStickyScrollbar(wrapper) {
    var _this = this;
    _classCallCheck(this, TableStickyScrollbar);
    _defineProperty(this, "sentinels", {});
    _defineProperty(this, "handleScroll", function (event) {
      if (!_this.stickyScrollbarContainerElement || !_this.wrapper || event.target !== _this.stickyScrollbarContainerElement) {
        return;
      }
      _this.wrapper.scrollLeft = _this.stickyScrollbarContainerElement.scrollLeft;
    });
    this.wrapper = wrapper;
    this.init();
  }
  return _createClass(TableStickyScrollbar, [{
    key: "dispose",
    value: function dispose() {
      if (this.stickyScrollbarContainerElement) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
      }
      this.deleteIntersectionObserver();
    }
  }, {
    key: "scrollLeft",
    value: function scrollLeft(left) {
      if (this.stickyScrollbarContainerElement) {
        this.stickyScrollbarContainerElement.scrollLeft = left;
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this$wrapper$parentE;
      if (!this.wrapper) {
        return;
      }
      this.stickyScrollbarContainerElement = (_this$wrapper$parentE = this.wrapper.parentElement) === null || _this$wrapper$parentE === void 0 ? void 0 : _this$wrapper$parentE.querySelector(".".concat(TableSharedCssClassName.TABLE_STICKY_SCROLLBAR_CONTAINER));
      if (this.stickyScrollbarContainerElement) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
          passive: true
        });
      }
      this.createIntersectionObserver();
    }
  }, {
    key: "createIntersectionObserver",
    value: function createIntersectionObserver() {
      var _this2 = this,
        _this$wrapper,
        _this$wrapper2;
      this.rendererScrollableElement = window.document;
      if (!this.rendererScrollableElement || !this.wrapper) {
        return;
      }
      this.intersectionObserver = new IntersectionObserver(function (entries, _) {
        if (!_this2.stickyScrollbarContainerElement) {
          return;
        }
        entries.forEach(function (entry) {
          // Ignored via go/ees005
          // eslint-disable-next-line @atlaskit/editor/no-as-casting
          var target = entry.target;
          if (target.classList.contains(TableSharedCssClassName.TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) {
            _this2.sentinelBottomCallback(entry);
          }
          if (target.classList.contains(TableSharedCssClassName.TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) {
            _this2.sentinelTopCallback(entry);
          }
        });
      }, {
        root: this.rendererScrollableElement
      });

      // Ignored via go/ees005
      // eslint-disable-next-line @atlaskit/editor/no-as-casting
      this.sentinels.bottom = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.parentElement) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.getElementsByClassName(TableSharedCssClassName.TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.item(0);

      // Ignored via go/ees005
      // eslint-disable-next-line @atlaskit/editor/no-as-casting
      this.sentinels.top = (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.parentElement) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.getElementsByClassName(TableSharedCssClassName.TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.item(0);
      [this.sentinels.bottom, this.sentinels.top].forEach(function (el) {
        return (
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          _this2.intersectionObserver.observe(el)
        );
      });
    }
  }, {
    key: "deleteIntersectionObserver",
    value: function deleteIntersectionObserver() {
      if (this.intersectionObserver) {
        if (this.sentinels.bottom) {
          this.intersectionObserver.unobserve(this.sentinels.bottom);
        }
        this.intersectionObserver.disconnect();
      }
    }
  }, {
    key: "sentinelBottomCallback",
    value: function sentinelBottomCallback(entry) {
      var _entry$rootBounds;
      var sentinelIsAboveScrollArea = entry.boundingClientRect.top < (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.top) || 0);
      this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
      this.toggle();
    }
  }, {
    key: "sentinelTopCallback",
    value: function sentinelTopCallback(entry) {
      var _entry$rootBounds2;
      var sentinelIsBelowScrollArea = (((_entry$rootBounds2 = entry.rootBounds) === null || _entry$rootBounds2 === void 0 ? void 0 : _entry$rootBounds2.bottom) || 0) < entry.boundingClientRect.top;
      this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
      this.toggle();
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') {
        this.stickyScrollbarContainerElement.style.visibility = 'hidden';
      }
    }
  }, {
    key: "show",
    value: function show() {
      if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') {
        this.stickyScrollbarContainerElement.style.visibility = 'visible';
      }
    }
  }]);
}();